<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button v-if="(resource.idEstatusSolicitud == 2 || resource.idEstatusSolicitud == 4 || resource.idEstatusSolicitud == 6) && $localStorageService.can('BT_01_Reas_Diagn')"
      @click="putCambiarEstatusSolicitud(data.item.idSolicitudEtapa, 1)"
      variant="outline-warning"
      >Regresar a estatus Pendiente</b-button>
  </div>
</template>

<script>
export default {
  name: "BandejaRegresarEstatusPendienteComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    putCambiarEstatusSolicitud(idSolicitudEtapa, idEstatusSolicitud) {
      var params = {
        idSolicitudEtapa: idSolicitudEtapa,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
        idEstatus : 1
      };

      this.$http
        .put(
          this.$api +
            "hallazgo/bandeja/cdx/actualizarestatussolicitud",
          params
          
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => (this.funcionExtraBandeja(idEstatusSolicitud)));
    },
    funcionExtraBandeja(idEstatusSolicitud) {
      this.$emit("_funcionExtra", idEstatusSolicitud);
    },
  },
};
</script>
